import gql from 'graphql-tag';

export const add = gql`mutation CreateCost($cost: CostInput!) {
    createCost(cost: $cost) {
        id
        creationDate
        invoiceNumber
        label
        totalCost
        url
        company {
            id
            name
        }
    }
}`;


export const edit = gql`mutation EditCost($id: ID!, $cost: CostInput!) {
    editCost(id: $id, cost: $cost) {
        id
        creationDate
        invoiceNumber
        totalCost
        label
        url
        company {
            id
            name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/cost.js